import React, { Component } from 'react';
import { Utilities } from '@polestar/content-plugin-core';
import { map } from 'lodash-es';
import * as PropTypes from 'prop-types';

export default class RecordStatus extends Component {
  render() {
    const record = this.props.record;
    const plugin = this.props.plugin;

    return (
      <div className="statusCard">
        <div>
          <a href={Utilities.getRecordUrl(plugin.site.attributes.internal_domain, record)} target="blank">
            {`${record.titleField} ${record.id}`}
          </a>
          <div>
            {record.breadcrumbs.map((path, index) => {
              return (
                // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                <p key={index} className="breadCrumb">
                  {path}
                </p>
              );
            })}
          </div>
        </div>
        <div className="statusContainer">
          {map(plugin.site.attributes.locales, (lang, index) => (
            <div key={lang} className="status">
              <div className={`dot ${record.translationStatus[lang].color} tooltip`}>
                <div className={`tooltiptext ${index < 5 ? 'tooltip-right' : 'tooltip-left'}`}>
                  {record.translationStatus[lang].fieldStatuses.map((fstatus, index) => (
                    // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                    <p key={index} style={{ whiteSpace: 'nowrap' }}>
                      <span className="tooltip-field-text">{fstatus.name}</span>
                      <span>: {fstatus.status}</span>
                    </p>
                  ))}
                </div>
              </div>
              <span className="localeText">{lang}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
RecordStatus.propTypes = {
  plugin: PropTypes.object,
  record: PropTypes.object
};
